<template>
  <v-col>
    <bread-crumbs />

    <v-row
      v-if="showSummaries"
      class="ma-0"
    >
      <v-col>
        <summary-card-bar />
      </v-col>
    </v-row>

    <v-row class="ma-0">
      <v-col>
        <report-list v-if="showDashboard" />

        <v-row v-else>
          <data-table
            ref="table"
            :actions="actions"
          >
            <template v-slot:empty-state>
              <div>Selected publisher has no Discrepancy data.</div>
            </template>
          </data-table>

          <creatives-discrepancy-modal />
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Discrepancy',
  components: {
    BreadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    DataTable: () => import('@/tools/components/table/DataTable'),
    CreativesDiscrepancyModal: () => import('../components/modals/CreativesDiscrepancyModal'),
    ReportList: () => import('@/dashboard/components/ReportList'),
    SummaryCardBar: () => import('@/tools/components/summary/SummaryCardBar'),
  },
  data() {
    return {
      actions: [
        {
          event: 'delivery/openTabToLineItem',
          name: 'Go to Line Item',
        },
        {
          event: 'delivery/openTabToOrder',
          name: 'Go to Order',
        },
        {
          event: 'delivery/showCreativesDiscrepancyModal',
          name: 'Creatives Discrepancy',
        },
      ],
    }
  },
  computed: {
    ...mapToolsGetters([
      'showSummaries',
    ]),
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),
    showDashboard() {
      return this.selectedSearch?.dataType === 'custom'
    },
  },
}
</script>
